import { OccupantAddress } from '@centecomm/portal-service';
import { BusinessUser } from './Types/BusinessUser';
import { Occupant } from './Types/Occupant';
import { Role, RoleId } from './Types/Role';

export enum BusinessActions {
    LOAD_BUSINESS_OCCUPANT = 'LOAD_BUSINESS_OCCUPANT',
    SET_BUSINESS_OCCUPANT = 'SET_BUSINESS_OCCUPANT',
    SET_BUSINESS_OCCUPANT_ERROR_STATE = 'SET_BUSINESS_OCCUPANT_ERROR_STATE',
    LOAD_BUSINESS_OCCUPANTS = 'LOAD_BUSINESS_OCCUPANTS',
    SET_BUSINESS_OCCUPANTS = 'SET_BUSINESS_OCCUPANTS',
    SET_BUSINESS_OCCUPANTS_ERROR_STATE = 'SET_BUSINESS_OCCUPANTS_ERROR_STATE',
    UPDATE_BUSINESS_OCCUPANT_MAILING_ADDRESS = 'UPDATE_BUSINESS_OCCUPANT_MAILING_ADDRESS',
    LOAD_BUSINESS_USERS_FOR_OCCUPANT = 'LOAD_BUSINESS_USERS_FOR_OCCUPANT',
    SET_BUSINESS_USERS_FOR_OCCUPANT = 'SET_BUSINESS_USERS_FOR_OCCUPANT',
    SET_BUSINESS_USERS_FOR_OCCUPANT_ERROR_STATE = 'SET_BUSINESS_USERS_FOR_OCCUPANT_ERROR_STATE',
    ADD_BUSINESS_USER_ROLE = 'ADD_BUSINESS_USER_ROLE',
    REMOVE_BUSINESS_USER_ROLE = 'REMOVE_BUSINESS_USER_ROLE',
    REMOVE_BUSINESS_USER = 'REMOVE_BUSINESS_USER',
    LOAD_BUSINESS_ROLES = 'LOAD_BUSINESS_ROLES',
    SET_BUSINESS_ROLES = 'SET_BUSINESS_ROLES',
    SET_BUSINESS_ROLES_ERROR_STATE = 'SET_BUSINESS_ROLES_ERROR_STATE',
}

type OccupantId = number;

interface LoadOccupantAction {
    type: typeof BusinessActions.LOAD_BUSINESS_OCCUPANT;
    payload: OccupantId;
}

interface SetOccupantAction {
    type: typeof BusinessActions.SET_BUSINESS_OCCUPANT;
    payload: Occupant;
}

interface SetOccupantErrorStateAction {
    type: typeof BusinessActions.SET_BUSINESS_OCCUPANT_ERROR_STATE;
    payload: {
        occupantId: OccupantId;
        errorMessage: string;
    };
}

interface LoadOccupantsAction {
    type: typeof BusinessActions.LOAD_BUSINESS_OCCUPANTS;
}

interface SetOccupantsAction {
    type: typeof BusinessActions.SET_BUSINESS_OCCUPANTS;
    payload: Occupant[];
}

interface SetOccupantsErrorStateAction {
    type: typeof BusinessActions.SET_BUSINESS_OCCUPANTS_ERROR_STATE;
    payload: {
        errorMessage: string;
        secondaryMessage?: string;
    };
}

interface UpdateMAilingAddressAction {
    type: typeof BusinessActions.UPDATE_BUSINESS_OCCUPANT_MAILING_ADDRESS;
    payload: {
        occupantId: OccupantId;
        address: OccupantAddress;
    };
}

interface LoadUsersForOccupantAction {
    type: typeof BusinessActions.LOAD_BUSINESS_USERS_FOR_OCCUPANT;
    payload: OccupantId;
}

interface SetUsersForOccupantAction {
    type: typeof BusinessActions.SET_BUSINESS_USERS_FOR_OCCUPANT;
    payload: {
        occupantId: OccupantId;
        users: BusinessUser[];
    };
}

interface SetUsersForOccupantErrorStateAction {
    type: typeof BusinessActions.SET_BUSINESS_USERS_FOR_OCCUPANT_ERROR_STATE;
    payload: {
        occupantId: OccupantId;
        errorMessage: string;
    };
}

interface AddUserRoleAction {
    type: typeof BusinessActions.ADD_BUSINESS_USER_ROLE;
    payload: {
        occupantId: OccupantId;
        userId: number | string;
        roleId: RoleId;
    };
}

interface RemoveUserRoleAction {
    type: typeof BusinessActions.REMOVE_BUSINESS_USER_ROLE;
    payload: {
        occupantId: OccupantId;
        userId: number | string;
        roleId: RoleId;
    };
}

interface RemoveUserAction {
    type: typeof BusinessActions.REMOVE_BUSINESS_USER;
    payload: {
        occupantId: OccupantId;
        userId: number;
    };
}

interface LoadRolesAction {
    type: typeof BusinessActions.LOAD_BUSINESS_ROLES;
    payload: OccupantId;
}

interface SetRolesAction {
    type: typeof BusinessActions.SET_BUSINESS_ROLES;
    payload: {
        occupantId: OccupantId;
        roles: Role[];
    };
}

interface SetRolesErrorStateAction {
    type: typeof BusinessActions.SET_BUSINESS_ROLES_ERROR_STATE;
    payload: {
        occupantId: OccupantId;
        errorMessage: string;
    };
}

export type BusinessActionTypes =
    | LoadOccupantAction
    | SetOccupantAction
    | SetOccupantErrorStateAction
    | LoadOccupantsAction
    | SetOccupantsAction
    | SetOccupantsErrorStateAction
    | UpdateMAilingAddressAction
    | LoadUsersForOccupantAction
    | SetUsersForOccupantAction
    | SetUsersForOccupantErrorStateAction
    | AddUserRoleAction
    | RemoveUserRoleAction
    | RemoveUserAction
    | LoadRolesAction
    | SetRolesAction
    | SetRolesErrorStateAction;
